import type { Ad, EmailContent } from "@models/Ad.model";
import type { AdCardRendererProps } from "../types";

function stripHtml(html: string): string {
    return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

function getSubject(ad: Ad): string {
    // The real subject line, now that EmailContent carries one (MPN-1716). Before it did,
    // the ad's name was the only thing available — which meant a reviewer approving a
    // template saw its internal name where the recipient will see the subject, and a
    // template with no subject at all looked complete. It cannot be sent without one.
    const content = ad.content as EmailContent | undefined;
    return content?.subject?.trim() || ad.name || "(no subject)";
}

function getPreheader(ad: Ad): string {
    const content = ad.content as EmailContent | undefined;
    return content?.preheader?.trim() ?? "";
}

function getBody(ad: Ad): string {
    const content = ad.content as EmailContent | undefined;
    return content?.html ? stripHtml(content.html) : "";
}

export default function AdCardEmail({ ad, mode }: AdCardRendererProps) {
    const clampClass =
        mode === "compact" ? "adcard-email__body--compact"
        : mode === "full" ? "adcard-email__body--full"
        : "adcard-email__body--detail";

    return (
        <>
            <div className="adcard-email__subj-row">
                <div className="adcard-email__subj-label">Subject</div>
                <div className="adcard-email__subj-val">{getSubject(ad)}</div>
            </div>
            {getPreheader(ad) && (
                <div className="adcard-email__subj-row">
                    <div className="adcard-email__subj-label">Preheader</div>
                    <div className="adcard-email__subj-val">{getPreheader(ad)}</div>
                </div>
            )}
            <div className={`adcard-email__body ${clampClass}`}>
                {getBody(ad) || <span className="adcard-email__empty">(no body)</span>}
            </div>
        </>
    );
}
